"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Check = function () {
  function Check() {}

  Check.isFunction = function (input) {
    return '[object Function]' === Object.prototype.toString.call(input);
  };

  Check.isString = function (input) {
    return '[object String]' === Object.prototype.toString.call(input);
  };

  Check.isNumber = function (input) {
    return '[object Number]' === Object.prototype.toString.call(input) && !isNaN(input);
  };

  Check.isObject = function (input) {
    return '[object Object]' === Object.prototype.toString.call(input);
  };

  Check.isDate = function (input) {
    return '[object Date]' === Object.prototype.toString.call(input) && input.toString() !== "Invalid Date";
  };

  Check.isArray = function (expectedArray) {
    return Array.isArray(expectedArray);
  };

  Check.isArrayOfStrings = function (expectedArray) {
    if (!Array.isArray(expectedArray)) {
      return false;
    }

    for (var i = 0; i < expectedArray.length; i++) {
      if (!Check.isString(expectedArray[i])) {
        return false;
      }
    }

    return true;
  };

  Check.isBoolean = function (input) {
    return true === input || false === input || '[object Boolean]' === Object.prototype.toString.call(input);
  };

  Check.isError = function (input) {
    return '[object Error]' === Object.prototype.toString.call(input);
  };

  Check.isSymbol = function (input) {
    return '[object Symbol]' === Object.prototype.toString.call(input);
  };

  Check.isUndefined = function (input) {
    return '[object Undefined]' === Object.prototype.toString.call(input);
  };

  Check.isNull = function (value) {
    return value === null;
  };

  Check.isNullOrUndefined = function (input) {
    return this.isNull(input) || this.isUndefined(input);
  };

  Check.isEmpty = function (input) {
    if (Check.isNullOrUndefined(input)) {
      return true;
    }

    if (Check.isString(input) || Check.isArray(input)) {
      return input.length === 0;
    }

    return Check.isObject(input) && Object.keys(input).length === 0;
  };

  return Check;
}();

exports.Check = Check;